import { render, staticRenderFns } from "./carikartmuhkodupdatebase.vue?vue&type=template&id=48f8d169"
import script from "./carikartmuhkodupdatebase.vue?vue&type=script&lang=js"
export * from "./carikartmuhkodupdatebase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports